import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { MapPinIcon, PhoneIcon, MailIcon, CheckCircleIcon } from 'lucide-react';
export function ContactPage() {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    subject: '',
    message: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real application, you would send the form data to your backend
    console.log('Form submitted:', formData);
    setFormSubmitted(true);
    // Reset form
    setFormData({
      name: '',
      email: '',
      company: '',
      subject: '',
      message: ''
    });
  };
  return <div className="w-full" data-id="element-396">
      {/* Hero Section */}
      <section className="bg-black text-white py-20 relative" data-id="element-397">
        <div className="absolute inset-0 z-0 overflow-hidden" data-id="element-398">
          <img src="https://images.unsplash.com/photo-1497366754035-f200968a6e72?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80" alt="Contact Hero" className="w-full h-full object-cover opacity-50" data-id="element-399" />
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-400">
          <div className="max-w-3xl" data-id="element-401">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-402">Contact Us</h1>
            <p className="text-xl text-gray-300" data-id="element-403">
              Get in touch with our team to discuss partnership opportunities,
              investment inquiries, or learn more about our ventures.
            </p>
          </div>
        </div>
      </section>
      {/* Contact Information */}
      <section className="py-16 bg-white" data-id="element-404">
        <div className="container mx-auto px-4" data-id="element-405">
          <div className="max-w-6xl mx-auto" data-id="element-406">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-407">
              <div className="bg-gray-50 p-8 rounded-lg" data-id="element-408">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-409">
                  <MapPinIcon className="h-8 w-8 text-black" data-id="element-410" />
                </div>
                <h3 className="text-xl font-semibold text-black mb-3 text-center" data-id="element-411">
                  Our Locations
                </h3>
                <div className="space-y-4" data-id="element-412">
                  <div data-id="element-413">
                    <p className="font-medium text-black text-center" data-id="element-414">
                      Dubai (Headquarters)
                    </p>
                    <p className="text-gray-600 text-center" data-id="element-415">
                      Lincoln Park, Barsha South
                    </p>
                  </div>
                  <div data-id="element-416">
                    <p className="font-medium text-black text-center" data-id="element-417">
                      Bangalore
                    </p>
                  </div>
                  <div data-id="element-418">
                    <p className="font-medium text-black text-center" data-id="element-419">London</p>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 p-8 rounded-lg text-center" data-id="element-420">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-421">
                  <PhoneIcon className="h-8 w-8 text-black" data-id="element-422" />
                </div>
                <h3 className="text-xl font-semibold text-black mb-3" data-id="element-423">Phone</h3>
                <p className="text-gray-600" data-id="element-424">+971-564684336</p>
              </div>
              <div className="bg-gray-50 p-8 rounded-lg text-center" data-id="element-425">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-426">
                  <MailIcon className="h-8 w-8 text-black" data-id="element-427" />
                </div>
                <h3 className="text-xl font-semibold text-black mb-3" data-id="element-428">Email</h3>
                <p className="text-gray-600" data-id="element-429">Ramzad@rawfounders.com</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Contact Form */}
      <section className="py-16 bg-gray-50" data-id="element-430">
        <div className="container mx-auto px-4" data-id="element-431">
          <div className="max-w-3xl mx-auto" data-id="element-432">
            <div className="bg-white p-8 md:p-12 rounded-lg shadow-sm" data-id="element-433">
              <h2 className="text-3xl font-bold text-black mb-6 text-center" data-id="element-434">
                Send Us a Message
              </h2>
              <p className="text-gray-600 mb-8 text-center" data-id="element-435">
                Complete the form below and we'll get back to you as soon as
                possible.
              </p>
              {formSubmitted ? <div className="bg-green-50 text-green-700 p-6 rounded-lg flex items-center" data-id="element-436">
                  <CheckCircleIcon className="h-6 w-6 mr-3" data-id="element-437" />
                  <div data-id="element-438">
                    <h3 className="font-semibold" data-id="element-439">
                      Thank you for contacting us!
                    </h3>
                    <p data-id="element-440">We've received your message and will respond shortly.</p>
                  </div>
                </div> : <form onSubmit={handleSubmit} data-id="element-441">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-442">
                    <div data-id="element-443">
                      <label htmlFor="name" className="block text-gray-700 font-medium mb-2" data-id="element-444">
                        Full Name <span className="text-red-500" data-id="element-445">*</span>
                      </label>
                      <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black" data-id="element-446" />
                    </div>
                    <div data-id="element-447">
                      <label htmlFor="email" className="block text-gray-700 font-medium mb-2" data-id="element-448">
                        Email Address <span className="text-red-500" data-id="element-449">*</span>
                      </label>
                      <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black" data-id="element-450" />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-451">
                    <div data-id="element-452">
                      <label htmlFor="company" className="block text-gray-700 font-medium mb-2" data-id="element-453">
                        Company
                      </label>
                      <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black" data-id="element-454" />
                    </div>
                    <div data-id="element-455">
                      <label htmlFor="subject" className="block text-gray-700 font-medium mb-2" data-id="element-456">
                        Subject <span className="text-red-500" data-id="element-457">*</span>
                      </label>
                      <select id="subject" name="subject" value={formData.subject} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black" data-id="element-458">
                        <option value="" data-id="element-459">Select a subject</option>
                        <option value="General Inquiry" data-id="element-460">General Inquiry</option>
                        <option value="Partnership Opportunity" data-id="element-461">
                          Partnership Opportunity
                        </option>
                        <option value="Investment Inquiry" data-id="element-462">
                          Investment Inquiry
                        </option>
                        <option value="Media Inquiry" data-id="element-463">Media Inquiry</option>
                        <option value="Career Opportunity" data-id="element-464">
                          Career Opportunity
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-6" data-id="element-465">
                    <label htmlFor="message" className="block text-gray-700 font-medium mb-2" data-id="element-466">
                      Message <span className="text-red-500" data-id="element-467">*</span>
                    </label>
                    <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={6} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black" data-id="element-468"></textarea>
                  </div>
                  <div className="text-center" data-id="element-469">
                    <Button type="submit" size="lg" data-id="element-470">
                      Send Message
                    </Button>
                  </div>
                </form>}
            </div>
          </div>
        </div>
      </section>
    </div>;
}